export const FEATURE_FLAGS = {
  BATCH_AGENT: 'BATCH_AGENT',
  BATCH_LEGACY: 'BATCH_LEGACY',
  BUREAU_COMPOSER: 'BUREAU_COMPOSER',
} as const;
